// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes iu-show{0%{opacity:0}to{opacity:1}}@keyframes spin{to{transform:rotate(1turn)}}body[widget-iu-loaded] [widget-iu-button]{visibility:visible!important;pointer-events:all!important}@media(min-width:768px){.modal-md{--bs-modal-width:calc(610px + var(--modal-dialog-space)*2)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
